import * as React from 'react';
export const exportSvg = React.forwardRef(function exportSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M10.75 7.25a.75.75 0 0 1 .75.75v2.75a.75.75 0 0 1-.75.75h-9.5a.75.75 0 0 1-.75-.75V8A.75.75 0 0 1 2 8v2h8V8a.75.75 0 0 1 .75-.75Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M6.47.219a.752.752 0 0 1 1.061 0l3 3.007a.752.752 0 0 1 0 1.06l-3 2.995A.751.751 0 0 1 6.47 6.22l1.716-1.713H5.5a.75.75 0 0 0-.75.75V8a.75.75 0 0 1-1.5 0V5.256a2.25 2.25 0 0 1 2.25-2.25h2.691L6.47 1.28a.751.751 0 0 1 0-1.061Z',
    }),
  );
});
exportSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var exportIcon = {
  category: 'icon',
  colorable: true,
  name: 'export',
  svg: exportSvg,
};
